// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import SessionDetailsView from "../../components/rgsICU/sessionDetails";

const SessionDetails = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <SessionDetailsView />
    </Main>
  </>
);

export default SessionDetails;
